import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDropzone } from 'react-dropzone';
import { FaCloudUploadAlt } from 'react-icons/fa';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { uploadShuttleDocument } from 'redux/booking/travel/travelBookingSlice';

const ShuttleUploadAttachmentDirectly = ({ booking, shuttle }) => {
  const dispatch = useDispatch();

  const onDrop = useCallback((acceptedFiles) => {
    try {
      dispatch(uploadShuttleDocument({ bookingId: booking.id, shuttleId: shuttle.id, data: { files: acceptedFiles } }));
    } catch (error) {
      toast.error(error.message);
    }
  }, [booking.id, shuttle.id, dispatch]);

  const { getRootProps, getInputProps } = useDropzone({ onDrop, accept: ['image/*', 'application/pdf'], multiple: true });

  return (
    <div
      {...getRootProps({
        className: 'tw-flex tw-items-center tw-justify-center tw-gap-2 tw-border-2 tw-border-dashed tw-border-slate-300 tw-rounded tw-py-8 tw-bg-slate-50 tw-cursor-pointer hover:tw-border-blue-400 tw-transition-colors',
      })}
    >
      <input {...getInputProps()} />
      <FaCloudUploadAlt size={24} className="tw-text-slate-400" />
      <p className="tw-mb-0 tw-text-sm tw-text-slate-600">Drop your files here</p>
    </div>
  );
};

ShuttleUploadAttachmentDirectly.propTypes = {
  booking: PropTypes.object.isRequired,
  shuttle: PropTypes.object.isRequired,
};

export default ShuttleUploadAttachmentDirectly;
